module.exports = __webpack_public_path__ + "media/Sim, estou.6ea1b5cf.mp3";